export default __webpack_public_path__ + "static/Figtree-Black-c22a18b1324557d93209d4fc0d9b915c.woff2";